module.exports = __webpack_public_path__ + "static/media/10_bluetooth-module.80102479.mp4";